import { Order } from '../Table/types';
import { Columns, HeadCell } from './types';

export const headCells: HeadCell[] = [
  { id: Columns.FullName, label: 'Full name', order: Order.Asc },
  { id: Columns.Email, label: 'Email', order: Order.Asc },
  { id: Columns.Roles, label: 'Roles in organisation', order: Order.NA },
  { id: Columns.CreditorNumber, label: 'Creditor number', order: Order.NA },
  { id: Columns.BusinessUnit, label: 'Business unit', order: Order.NA },
  { id: Columns.Status, label: 'Status', order: Order.Asc },
  { id: Columns.Link, label: 'Actions', order: Order.NA },
];
